import React, {useEffect} from 'react';
import {ROUTERS_MAP} from "../../utils/routes";
import {Route} from "react-router-dom";
import CopilotPage from "./Copilot/CopilotPage";
import AiAgentsPage from "../AiAgentsPage/AiAgentsPage";

const AiTeamsPage = () => {

    return (
        <div>
            <Route path={`${ROUTERS_MAP.COPILOT}`} exact component={CopilotPage}/>
            <Route
                path={ROUTERS_MAP.AI_AGENTS}
                component={AiAgentsPage}
            />
        </div>
    );
};

export default AiTeamsPage;